import styled from 'styled-components';

export const Card = styled.div`
  box-shadow:
    0px 2px 6px rgba(0, 0, 0, 0.07),
    0px 0px 2px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.spacings.abs8}px;
  padding: ${({ theme }) => theme.spacings.abs32}px;
  margin: ${({ theme }) => theme.spacings.abs24}px 0;
`;

export default Card;
